export default __webpack_public_path__ + "static/media/Group9166.b6b162a6.svg";